const s = require("../monitoring/monitoring.module.scss");
import * as React from "react";

import TDatetime from "components/TDatetime";
import { MonitoringFailedDto } from "core/backend/common";

interface OwnProps {
    dto: MonitoringFailedDto;
    left: number;
}
const Row = ({ dto, left }: OwnProps) =>
    <tr className="small">
        <TDatetime rowSpan={1} date={new Date(dto.businessDayUtc)} left={left} />
        <td className="alignLeft">{dto.fileName}</td>
        <td className="alignLeft">{dto.error}</td>
    </tr>

export default Row;